import React from 'react'
import HomeTemplate from '../templates/Home'
import localizations from '../localization/en/home'
import { i18n } from '../utils/i18n'
import testimonials from '../data/testimonials'

const IndexPage = ({ logo, locale, data }) => (
  <HomeTemplate
    data={data}
    logo={logo}
    locale={locale}
    i18n={i18n(localizations)}
  />
)

export default IndexPage

export const imagesQuery = graphql`
  query HomeImagesQuery {
    ...HomeImages
  }
`



// WEBPACK FOOTER //
// ./src/pages/index.js